export default __webpack_public_path__ + "static/Emma-1384890b0c332b769f67e8c14b628e13.png";